<!--
 * @Date: 2024-11-25 17:53:45
 * @LastEditors: 'lidianbin' 'lidianbin@coocaa.com'
 * @LastEditTime: 2025-06-06 16:09:09
 * @FilePath: \cms_main_site\src\App.vue
-->
<template>
  <div id="app">
    <router-view class="content-wrapper"/>
    <right-floating-layer ref="rightFL"></right-floating-layer>
    <!-- <global-dialog></global-dialog> -->
  </div>
</template>
<script>
import rightFloatingLayer from '@/components/layout/RightFloatingLayer.vue'
// import GlobalDialog from '@/components/layout/GlobalDialog.vue'
export default {
  components: {
    rightFloatingLayer
    // GlobalDialog
  }
}
</script>
<style lang="stylus" scoped>
// .content-wrapper
//    min-width 1200px
// @media screen and (max-width $mobile-width)
//  .content-wrapper
//    min-width auto
</style>
